import { createQueryParams } from './../utils/stringUtils';
import endpoints from "../utils/endpoints";
import { message } from "antd";
import { Api } from "./api";
import { removeEmpty } from "../utils/objectUtils";
import { notificationError } from "./notification";

export async function getLogsList(params: any){
    let res = {
      count: 0,
      page: null,
      perpage: 0,
      list: [],
    };
    params = removeEmpty(params)
    await Api.get(endpoints.getLogsList, { params}).then((response) => {
      if(response.status === 200) {
        if(response.data.error) {
          notificationError(`${response.data.message}`)
        } else {
          res = response.data
        }
      } else {
        notificationError('Could not get logs')
      }
    }).catch((err: string) => {
      notificationError('Could not get logs')
    })
    
    return res
}

export async function getLogsById(params: any){
    let res = {
        changes: {},
        full: {
            "new info": {},
            "old info": {}
        }
    };
    await Api.get(endpoints.getLogsById, { params}).then((response) => {
      if(response.status !== 200 || response.data?.error || response.data?.return === false) {
        return notificationError('Could not get log details')
      }
      res = response.data
    }).catch((err: string) => {
      notificationError('Could not get log details')
    })
    
    return res
}

export async function exportCsvLogs(params: any){
    let res = ''
    const query = createQueryParams(params)
    await Api.get(`${endpoints.exportCsvLogs}?${query}`).then((response) => {
      res = response.data
    }).catch((err: string) => {
      notificationError('Could not get data from servers')
    })
    window.open("data:text/csv;charset=utf-8," + escape(res))
}


